import React from 'react';
import PreviewPost from "./Components/PostMediaPreview/PreviewPost";

const PostPreviewPage = () => {
    return (
        <PreviewPost/>
    );
};

export default PostPreviewPage;